import { render } from "./FamilyManagement.vue?vue&type=template&id=652e8458&scoped=true"
import script from "./FamilyManagement.vue?vue&type=script&lang=js"
export * from "./FamilyManagement.vue?vue&type=script&lang=js"

import "./FamilyManagement.vue?vue&type=style&index=0&id=652e8458&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652e8458"]])

export default __exports__